import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { FaLinkedin, FaTwitterSquare } from "react-icons/fa";
import contactOne from "../../img/FinalEdit/connection.png";
import contactThee from "../../img/FinalEdit/contactThree.png";
import ContactForm from "./ContactForm";
const Contacts = () => {

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);


  return (
    <div className="container px-10 mx-auto mt-10 mb-20">
      <div
        data-aos="fade-down"
        className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12"
      >
        <div data-aos="flip-right">
          <img
            className="object-contain h-full w-full"
            src={contactOne}
            alt=""
          />
        </div>
        <div>
          <h1
            data-aos="flip-left"
            className="mt-6 pt-6 text-center mb-2 font-bold text-4xl md:text-5xl lg:text-6xl"
          >
            Contact
          </h1>
          <h3 className="pt-6 text-center mb-2 font-bold text-2xl md:text-2xl lg:text-2xl">
            
            If you have some query about me.please email me ❤
          </h3>
          <div className="flex my-8 justify-center">
     <ContactForm />
     </div>

          
        </div>
      </div>

      <div className="my-10">
      
      <div
        data-aos="fade-down"
        className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12"
      >

      <div>
      <h1 className="pt-40 text-center mb-2 font-bold text-2xl md:text-2xl lg:text-2xl">
      Find me on the web! For contacting, I prefer mail.
      </h1>

      <div className="flex my-8 justify-center">
            <div>
              <a target="_blank" href="https://twitter.com/mdrianislam0or1" rel="noreferrer">
                <FaTwitterSquare className="text-blue-500 mx-3 sm:text-4xl md:text-4xl lg:text-5xl" />
              </a>
            </div>
            <div>
              <a target="_blank" href="https://www.linkedin.com/in/mdrianislam0or1/" rel="noreferrer">
                <FaLinkedin className="text-blue-500  sm:text-4xl md:text-4xl lg:text-5xl" />
              </a>
            </div>
          </div>
     
      </div>


      <div data-aos="fade-down">
          <img
            className="object-contain h-full w-full"
            src={contactThee}
            alt=""
          />
        </div>



      

      </div>
      </div>







      
    </div>
  );
};

export default Contacts;
